import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import ContentLabel from 'views/Content/ContentLabel';
import { Container, Row, Col } from 'reactstrap';
import Intro from "./Intro.js";
import { useIntl } from 'react-intl';

export default function MediaLQDTU() {
    const intl = useIntl();

    const mediaItems = [
        {
            title: intl.formatMessage({ id: 'Brand identity system' }),
            content: intl.formatMessage({ id: 'Brand identity system description' }),
            image: require('assets/img/custom/media/Group 71.png').default,
            imgtil: "BRANDING",
            linkSrc: '/brand-identity'
        },
        {
            title: intl.formatMessage({ id: 'Image' }),
            content: intl.formatMessage({ id: 'Image description' }),
            image: require('assets/img/custom/media/Group 75.png').default,
            imgtil: "IMAGE",
            linkSrc: '/list/image/5'
        },
        {
            title: intl.formatMessage({ id: 'Video' }),
            content: intl.formatMessage({ id: 'Video description' }),
            image: require('assets/img/custom/media/Group 76.png').default,
            imgtil: "VIDEO",
            linkSrc: 'https://www.youtube.com/channel/UCGmbHJQJj91jUeiCe_zoaBg'
        }
    ];

    return (
        <>
            <Row style={{ margin: '40px 0' }}>
                {mediaItems.map((item, index) => (
                    <Intro key={index} info={item} />
                ))}
            </Row>
        </>
    )
}
